import { Observable } from "rxjs";
import { SubscribeToNewsletterEndpoint } from "src/endpoints/ContactsEndpoint";
import { contactStore } from "src/stores/contact.store";
import { getHttpService } from "../services/http.service";
const httpService = getHttpService();
export const subscribeToNewsletter = (): Observable<any> => {
    const contactDetails = contactStore.contact;
    const endpoint = new SubscribeToNewsletterEndpoint();
    return httpService.post(endpoint, { contact: { ...contactDetails } });
};
